/**
 * WordPress dependencies
 */
import { Component } from '@wordpress/element';

export class RichTextShortcut extends Component {
	render() {
		return null;
	}
}
